export default __webpack_public_path__ + "static/media/leftQuote.e8b7d3a1.svg";